/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MyBoardsIcon/view.blocks to change it.
import React from 'react'
import Tysiav2TaskMyBoardsIcon from 'DesignSystem/Svgs/Tysiav2TaskMyBoardsIcon/index'



/** @type {import('Simple/types.js').View} */
export default function MyBoardsIcon({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Header/Content/Content/Title/BoardListIcon/MyBoardsIcon"
  
}) {
  return (<React.Fragment
>
<Tysiav2TaskMyBoardsIcon
  viewPath={`${viewPath}/Tysiav2TaskMyBoardsIcon`}
/>
{children}
</React.Fragment>)
}